import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/2cf555d8-2b2e-4a65-8a76-f17be07c4f4a/images/3a6ccbd94dcf7c8dd2bb71e8eaac726f163f07a081c303340de9507a1d17e8f3.png";
const HERO_IMG_2 =
  "https://static.prod-images.emergentagent.com/jobs/2cf555d8-2b2e-4a65-8a76-f17be07c4f4a/images/17c8cb237e4f9c5b598a91469f15cccc2b2e147ca2cef00db3cd24c093ae891f.png";

const CATEGORIES = [
  { label: "Painting", img: HERO_IMG_2 },
  { label: "Mixed Media", img: HERO_IMG },
  { label: "Sculpture", img: "https://images.unsplash.com/photo-1577720580479-7d839d829c73?crop=entropy&cs=srgb&fm=jpg&w=600&q=70" },
  { label: "Photography", img: "https://images.unsplash.com/photo-1593620659530-71054be24c66?crop=entropy&cs=srgb&fm=jpg&w=600&q=70" },
];

export const CategoriesSection = () => (
  <section data-testid="categories-section" className="px-6 md:px-12 lg:px-24 py-20 bg-[#F4EFE6]/40 border-y border-[#E5E0D8]">
    <p className="label-eyebrow text-[#1E3A8A]">— Explore by Medium</p>
    <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight font-medium mt-2 text-[#111]">
      Browse art categories
    </h2>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
      {CATEGORIES.map((cat) => (
        <Link
          to={`/gallery?medium=${encodeURIComponent(cat.label)}`}
          key={cat.label}
          data-testid={`category-${cat.label.replace(/\s+/g, "-").toLowerCase()}`}
          className="group relative overflow-hidden h-64 block"
        >
          <img src={cat.img} alt={`${cat.label} — African contemporary art category`} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A8A]/85 via-[#1E3A8A]/30 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-5">
            <h3 className="font-serif-display text-2xl text-white font-medium">{cat.label}</h3>
            <p className="label-eyebrow text-[#F4C430] mt-1 inline-flex items-center gap-1">
              Browse <ArrowRight className="w-3 h-3" />
            </p>
          </div>
        </Link>
      ))}
    </div>
  </section>
);
